import Spinner from "@components/Spinner"
import { storeUserProfile } from "@helpers/supabase"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export default function PreparingPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [currentTextIndex, setCurrentTextIndex] = useState(0)

  // Array of three different loading messages
  const loadingMessages = [
    t("pages.signUp.loading.info1"),
    t("pages.signUp.loading.info2"),
    t("pages.signUp.loading.info3"),
  ]

  useEffect(() => {
    void storeUserProfile()

    // Redirect after 7 seconds
    const timeout = setTimeout(() => {
      navigate("/checkout/plans")
    }, 7000)
    return () => clearTimeout(timeout)
  }, [navigate])

  useEffect(() => {
    // Switch text every 2.33 seconds (7 seconds total / 3 messages)
    const textInterval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => {
        const nextIndex = prevIndex + 1
        // Stop cycling after showing all messages
        if (nextIndex >= loadingMessages.length) {
          clearInterval(textInterval)
          return prevIndex // Keep the last message visible
        }
        return nextIndex
      })
    }, 2333)

    return () => clearInterval(textInterval)
  }, [loadingMessages.length])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4">
      {/* Heading */}
      <h1 className="mb-2 text-center text-2xl font-bold text-gray-800">
        {t("pages.signUp.loading.heading")}
      </h1>

      {/* Subheading with rotating text */}
      <p className="mb-6 text-center text-lg text-gray-500 transition-opacity duration-500">
        {loadingMessages[currentTextIndex]}
      </p>

      {/* White card with spinner */}
      <Spinner />
    </div>
  )
}
